package com.milta.core.localization.translations.bg

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Абонаментът е изтекъл",
    driverSoloMessage = "Абонаментът ви е изтекъл. Подновете, за да продължите.",
    patronMessage = "Абонаментът ви е изтекъл. Вашият екип вече няма достъп до Milta.",
    driverUnderPatronMessage = "Абонаментът на вашата организация е изтекъл. Свържете се с организацията си, за да възстановите достъпа си.",
    renewButton = "Поднови",
    close = "Затвори",
    subscribeButtonTemplate = "Абонирайте се за %s",
)
